import { useDispatch } from 'react-redux';
import {
    SearchByFilters,
    SearchByFiltersCustom,
    SimpleSearch,
    SimpleSearchWithId
} from '../../../../../reduxToolkit/Search/SearchApi';
import {CRITERIA_MODEL, SEARCH_MODEL} from '../../../../../components/table/Model/TableModel';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param modified
 * @param finalArray
 * @param view
 * @param setCriteria
 * @param contractorId
 * @param supplierId
 * @param option
 * @param searchElement
 * @param setBodyForExport
 * @param setSearchResults
 * @param setSimpleSearch
 * @constructor
 */
const AllEmployeeDataApp = (
    {
        finalArray,
        view,
        setCriteria,
        contractorId,
        supplierId,
        option,
        searchElement,
        setBodyForExport,
        setSearchResults,
        setSimpleSearch
    }
) => {

    const dispatch = useDispatch();

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { rowsPerPage }) => {
        const userId = contractorId ?? supplierId;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            view,
            key: searchElement,
            model: option,
            ...(userId && { userId }),
        });
        setBodyForExport(body);
        const action = userId ? SimpleSearchWithId : SimpleSearch;
        dispatch(action({ body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setSearchResults(data);
        });
    };

    /**
     * Executes a paginated search request using advanced criteria.
     *
     * Builds the criteria list based on the advanced search (finalArray),
     * appends user criteria, and dispatches the search action through Redux.
     * Updates the results and resets the selected list once the data is returned.
     */
    const getDataAdvancedSearch = (page, { rowsPerPage }) => {
        const userToFindId = contractorId ?? supplierId;
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            rootGroup: CRITERIA_MODEL.set(finalArray),
            view,
            ...(userToFindId && { userToFindId }),
        });
        setCriteria(body);
        const action = userToFindId ? SearchByFiltersCustom : SearchByFilters;
        dispatch(action({ option, body })).then(({ payload: { data: { data, success } } }) => {
            if (success) setSearchResults(data);
        });
    };

    return {
        getData,
        getDataAdvancedSearch
    }
}

export default AllEmployeeDataApp
